import { sanitizeAcharyaAnswer } from "@/lib/acharya/sanitizeAcharyaAnswer";

/** Renders stable JSON fields (reflection → closing) with safe defaults. */
export function AcharyaAnswerBlocks({ data }) {
  const safe = sanitizeAcharyaAnswer(data);

  const sections = [
    { key: "reflection", title: "Reflection", body: safe.reflection },
    { key: "teaching", title: "Teaching", body: safe.teaching },
    { key: "story", title: "Story", body: safe.story },
    { key: "closing", title: "Closing", body: safe.closing },
  ].filter((s) => s.body?.trim() && s.body.toLowerCase() !== "null");

  if (!sections.length && !safe.steps.length && !safe.answer?.trim()) return null;

  return (
    <div className="mt-3 space-y-3" data-testid="acharya-answer-blocks">
      {sections.map((s) => (
        <div key={s.key} className="text-sm">
          <p className="font-medium text-foreground/90">{s.title}</p>
          <p className="text-muted-foreground whitespace-pre-wrap mt-1">{s.body}</p>
        </div>
      ))}
      {safe.steps.length > 0 && (
        <div className="text-sm">
          <p className="font-medium text-foreground/90">Practical steps</p>
          <ul className="list-decimal list-inside text-muted-foreground mt-1 space-y-1">
            {safe.steps.map((step, i) => (
              <li key={i}>{step}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
